import { create } from 'zustand';

// 프로젝트 Store
export const useProjectStore = create((set, get) => ({
  // State
  projects: [],
  selectedProject: null,
  isLoading: false,
  isCreateModalOpen: false,
  filter: 'all', // all | mine | shared
  searchQuery: '',

  // Actions
  setProjects: (projects) => set({ projects }),

  setSelectedProject: (project) => set({ selectedProject: project }),

  setLoading: (loading) => set({ isLoading: loading }),

  openCreateModal: () => set({ isCreateModalOpen: true }),

  closeCreateModal: () => set({ isCreateModalOpen: false }),

  setFilter: (filter) => set({ filter }),

  setSearchQuery: (query) => set({ searchQuery: query }),

  // Create Project
  addProject: (project) => set((state) => ({
    projects: [project, ...state.projects],
    isCreateModalOpen: false
  })),

  // Update Project
  updateProject: (projectId, updates) => set((state) => ({
    projects: state.projects.map((p) =>
      p.id === projectId ? { ...p, ...updates, updatedAt: new Date().toISOString() } : p
    ),
    selectedProject: state.selectedProject?.id === projectId
      ? { ...state.selectedProject, ...updates, updatedAt: new Date().toISOString() }
      : state.selectedProject
  })),

  // Delete Project
  deleteProject: (projectId) => set((state) => ({
    projects: state.projects.filter((p) => p.id !== projectId),
    selectedProject: state.selectedProject?.id === projectId ? null : state.selectedProject
  })),

  // Add Conversation to Project
  addConversation: (projectId, conversation) => set((state) => ({
    projects: state.projects.map((p) =>
      p.id === projectId
        ? {
            ...p,
            conversations: [...(p.conversations || []), conversation],
            updatedAt: new Date().toISOString()
          }
        : p
    )
  })),

  // Getters
  getFilteredProjects: () => {
    const { projects, filter, searchQuery } = get();
    const currentUserId = getCurrentUserId();

    let filtered = projects;

    // Filter by ownership
    if (filter === 'mine') {
      filtered = filtered.filter((p) => p.ownerId === currentUserId);
    } else if (filter === 'shared') {
      filtered = filtered.filter((p) =>
        p.ownerId !== currentUserId &&
        (p.sharedWith?.includes(currentUserId) || p.sharedWith?.includes('all'))
      );
    }

    // Search filter
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter((p) =>
        p.name.toLowerCase().includes(query) ||
        p.description?.toLowerCase().includes(query)
      );
    }

    // Sort by updatedAt
    return [...filtered].sort((a, b) =>
      new Date(b.updatedAt) - new Date(a.updatedAt)
    );
  }
}));

// Helper: 현재 사용자 ID 가져오기
const getCurrentUserId = () => {
  try {
    const userInfoStr = localStorage.getItem('userInfo');
    if (userInfoStr) {
      const userInfo = JSON.parse(userInfoStr);
      return userInfo.userId || userInfo.sub || 'user_current';
    }
  } catch (error) {
    console.warn('[ProjectStore] Failed to get user ID:', error);
  }
  return 'user_current';
};

// 빈 배열 (실제 API 연동 전까지)
export const MOCK_PROJECTS = [];

export default useProjectStore;
